export default {
    computed: {
        currencyFormat() {
            return v => {
                if (typeof v == 'number') {
                    return v.toLocaleString('es-AR', {style: 'currency', currency: 'ARS'})
                }
                return v
            }
        }
    }
}
